<template>
  <div class="col-sm-12 col-md">
    <abstract-profile-text-input
      id="input-company_name"
      v-model="model"
      :error="errors"
      :label="computedLabel"
      :placeholder="computedPlaceholder"
      @change="inputChange"
      @input="onInput"
      :rules="required ? 'required' : ''"
    />
  </div>
</template>

<script>
import AbstractProfileTextInput from "../core/AbstractProfileTextInput";
import BaseInputMixin from "../../../../mixins/profileInputMixin";

export default {
  name: "CompanyName",
  components: {AbstractProfileTextInput},
  mixins: [BaseInputMixin('company_name')],

  data() {
    return {
      defaultLabel: this.$t("Company Name")
    }
  }
}
</script>

<style scoped>

</style>
